module.exports = __webpack_public_path__ + "img/android-logo.9290becc.svg";